import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const city = {
  fetchCities: lazyModuleMethod(() => import('./fetchCities'), 'default'),
}
